class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, '', this.closest('.cart-item'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.progressBarShipping();
    this.updateCartNotes();

    // Make Checkout buttons sticky only if it's the Cart page and it's a mobile device
    if (window.location.href.indexOf("/cart") !== -1 && window.innerWidth < 660) {
      this.stickyCheckoutButtons();
    }

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

 

  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), null);
  }


  addDeletedItemMesageCartPage(node) {
    let deletedID = '#' + node.getAttribute('id');
    let newID = parseInt(deletedID.split('-')[1] - 1);
    //If removed element is the last one, in the new appended cart items, the message should appear in the new last item
    if (newID == 0) {
      newID = 1;
    }
    // #CartItem-7
    let idToAppend = `#CartItem-${newID}`
    let productTitle = node.getAttribute('data-product-title');
    let productQuantity = node.getAttribute('data-product-quantity');
    let itemUrl = node.getAttribute('data-item-url');
    // let fullMessage = `<p class="item-removed"> "${themeLocales.removed}" (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag }</p>`;
    let nodeToAppend = document.querySelector(idToAppend);
    if (nodeToAppend) {
      //Condition to check if user removed last product from cart, in this case inject 'Remove message' before last item.
      if (parseInt(deletedID.split('-')[1] - 1) == 0) {

        let fullMessage = `<tr class="cart-item">
        <td>
          <p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>
        </td>
        </tr>`;
        nodeToAppend.insertAdjacentHTML('beforebegin', fullMessage)
      } else {
        let fullMessage = `
        <tr class="cart-item spacer"></tr>
        <tr class="cart-item">
          <td>
            <p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>
          </td>
          </tr>`;
        nodeToAppend.insertAdjacentHTML('afterend', fullMessage)
      }
    }

  }
  addDeletedItemMesage(cartItems, node) {
    let deletedID = '#' + node.getAttribute('id');
    let newID = parseInt(deletedID.split('-')[2] - 1);
    //If removed element is the last one, in the new appended cart items, the message should appear in the new last item
    if (newID == 0) {
      newID = 1;
    }

    let idToAppend = `#CartDrawer-Item-${newID}`
    let productTitle = node.getAttribute('data-product-title');
    let productQuantity = node.getAttribute('data-cart-count');
    let itemUrl = node.getAttribute('data-item-url');
    let fullMessage = `<p class="item-removed"> ${themeLocales.removed} (${productQuantity}) <a href="${itemUrl}" class="item-title">${productTitle}</a> ${themeLocales.from_bag}</p>`;
    let nodeToAppend = document.querySelector(idToAppend);
    if (nodeToAppend) {
      //Condition to check if user removed last product from cart, in this case inject 'Remove message' before last item.
      if (parseInt(deletedID.split('-')[2] - 1) == 0) {
        nodeToAppend.insertAdjacentHTML('beforebegin', fullMessage)
      } else {
        nodeToAppend.insertAdjacentHTML('afterend', fullMessage)
      }
    }

    this.removeMessageFromDOM();

  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  outsideClick(event, notelem) {

    let clickedOut = true, i, len = notelem.length;
    for (i = 0; i < len; i++) {
      if (event.target == notelem[i] || notelem[i].contains(event.target)) {
        clickedOut = false;
      }
    }
    if (clickedOut) return true;
    else return false;
  }

  removeMessageFromDOM() {

    let itemToRemove = document.querySelector('.item-removed');
    let drawer_close = document.querySelector('.drawer__close');
    let drawer_overlay = document.querySelector('.drawer__overlay');
    let cartDrawer = document.querySelectorAll('#CartDrawer');


    drawer_close.addEventListener('click', () => {

      if (itemToRemove) {
        itemToRemove.remove();
      }
    })

    drawer_overlay.addEventListener('click', () => {
      if (itemToRemove) {
        itemToRemove.remove()
      }
    })

    let that = this;
    window.addEventListener('click', function (e) {
      if (that.outsideClick(e, cartDrawer)) {
        if (itemToRemove) {
          itemToRemove.remove()
        }
      }
    });

  }


  updateQuantity(line, quantity, name, deletedNode) {
    this.enableLoading(line);
    
    let body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    let cartBefore = [];
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('drawer-component[data-drawer="cart"]');
      const cartHeader = document.getElementById('main-cart-header');
      const cartFooter = document.getElementById('main-cart-footer');
      cartBefore = parsedState.items;

      if (cartHeader) cartHeader.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      this.updateLiveRegions(line, parsedState.item_count);
      const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
      }
      this.disableLoading();
      if(deletedNode) {
        this.addDeletedItemMesageCartPage(deletedNode);
        this.addDeletedItemMesage(parsedState, deletedNode);
      }
    }).then(() => {
      this.progressBarShipping();
      this.handleGTMEvents(cartBefore, line);
    }).catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      //errors.textContent = window.cartStrings.error;
      this.disableLoading();
    });
  }

  // Function to send GTM events after every cart change
  handleGTMEvents(cartBefore, line) {
    fetch("/cart.js")
    .then((response) => { return response.text(); })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const cartAfter = parsedState.items;
      const index = parseInt(line) - 1;
      const cartAfterPrepared = prepareItems(cartAfter);
      const difference = cartBefore.filter(obj1 => !cartAfter.some(obj2 => obj2.id === obj1.id));
      localStorage.setItem('cartItems', JSON.stringify(cartAfterPrepared));

      if (difference.length != 0)
        //send to GTM
        window.handleCart(difference[0], "remove_from_cart", index);
      else {
        const changedObjects = [];

        for (let i = 0; i < cartBefore.length; i++) {
          const obj1 = cartBefore[i];
          const obj2 = cartAfter.find(obj => obj.id === obj1.id);

          if (obj2 && obj1.quantity > obj2.quantity) {
            obj1.quantity = obj1.quantity - obj2.quantity;
            changedObjects.push(obj1);
            //send to GTM
            window.handleCart(changedObjects[0], "remove_from_cart", index);
          } else if (obj2 && obj1.quantity < obj2.quantity) {
            obj1.quantity = obj2.quantity - obj1.quantity;
            changedObjects.push(obj1);
            window.handleCart(changedObjects[0], "add_to_cart", index);
          }
        }
      }
    });    
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  progressBarShipping() {
    var country = Shopify.country;
    var shipping_threshold = country + 'FreeShippingThreshold';
    var freeThreshold = Math.round (100 * parseFloat(theme.settings[shipping_threshold]));

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        var carTotalPrice = data.total_price;
        var ProgressPercentage = Math.floor((100 * carTotalPrice) / freeThreshold);
        var ProgressBar;
        var ProgressBarMessage;
        var ProgressBarHtml = '';
        var ProgressBarMessageHtml = '';

        if (this.tagName == 'CART-DRAWER-ITEMS') {
          ProgressBar = this.querySelector('.progress_bar_shipping');
          ProgressBarMessage = this.querySelector('.progress_bar_shipping_message');
        }
        else if (this.tagName == 'CART-ITEMS') {
          ProgressBar = this.parentNode.parentNode.querySelector('.progress_bar_shipping_mb');
          ProgressBarMessage = this.parentNode.parentNode.querySelector('.progress_bar_shipping_message');
        }

        if (carTotalPrice < freeThreshold) {
          ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:'
            + ProgressPercentage + '%" aria-valuenow="'
            + ProgressPercentage + '" aria-valuemin="0" aria-valuemax="100">'
            + ProgressPercentage + '%</div></div>';
          ProgressBarMessageHtml = theme.strings.shippingMessage.replace("[price]", '<span data-js-price="' + (freeThreshold - carTotalPrice) + '">' + (freeThreshold - carTotalPrice) + '</span>');
          ProgressBar.classList.remove('success');
        }
        else {
          ProgressBarHtml = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div></div><span class="percent">100%</span>';
          ProgressBarMessageHtml = theme.strings.freeShipping;
          ProgressBar.classList.add('success');
        }

        ProgressBar.innerHTML = ProgressBarHtml;
        ProgressBarMessage.innerHTML = ProgressBarMessageHtml;
      })
      .then(function () {
        if (window.formatPrices) {
          window.formatPrices("[data-js-price]");
        }
      })
  }

  // Function that returns the user IP address
  async getUserIP() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      const ipAddress = data.ip;

      return ipAddress;
    }
    catch (error) {
      console.error('Error fetching IP address:', error);
      return null;
    }
  }

  // Returns user device name (iphone/ipad/windows/android etc...)
  getDeviceName() {
    var device = 'Desktop';

    if (navigator.userAgentData && navigator.userAgentData.mobile) {
      device = navigator.userAgentData.platform;
    } else if (/iPad/i.test(navigator.userAgent)) {
      device = 'iPad';
    } else if (/iPhone/i.test(navigator.userAgent)) {
      device = 'iPhone';
    } else if (/Android/i.test(navigator.userAgent)) {
      device = 'Android';
    } else if (/Windows Phone/i.test(navigator.userAgent)) {
      device = 'Windows Phone';
    } else if (/Tablet/i.test(navigator.userAgent)) {
      device = 'Tablet';
    }

    if (/Win/i.test(navigator.userAgent)) {
      device = 'Windows';
    } else if (/Mac/i.test(navigator.userAgent)) {
      device = 'Mac';
    } else if (/Linux/i.test(navigator.userAgent)) {
      device = 'Linux';
    }

    return device;
  }

  // Function to return browser details (name & version)
  getBrowserInfo() {
    var browserName = '';
    var browserVersion = '';

    if (/OPR/i.test(navigator.userAgent)) {
      browserName = 'Opera';
      browserVersion = navigator.userAgent.match(/OPR\/([\d.]+)/)[1];
    } else if (/Edg/i.test(navigator.userAgent)) {
      browserName = 'Microsoft Edge';
      browserVersion = navigator.userAgent.match(/Edg(?:e|A|iOS|W|\?)?\/([\d.]+)/i)[1];
    } else if (/Chrome/i.test(navigator.userAgent)) {
      browserName = 'Google Chrome';
      browserVersion = navigator.userAgent.match(/(?:Chrome|CriOS)\/([\d.]+)/)[1];
    } else if (/Safari/i.test(navigator.userAgent)) {
      browserName = 'Safari';
      if(navigator.userAgent.indexOf("Version") !== -1) {
        browserVersion = navigator.userAgent.match(/Version\/([\d.]+)/)[1];   
       } else if(navigator.userAgent.indexOf("CriOS") !== -1) {
        browserVersion = navigator.userAgent.match(/CriOS\/([\d.]+)/)[1]; 
       } 
    } else if (/Firefox/i.test(navigator.userAgent)) {
      browserName = 'Mozilla Firefox';
      browserVersion = navigator.userAgent.match(/(?:Firefox|FxiOS)\/([\d.]+)/)[1];
    } else {
      browserName = 'Unknown Browser';
      browserVersion = 'N/A';
    }

    return {
      browserName: browserName,
      browserVersion: browserVersion
    }
  }

  // Function to set the order notes value for device name
  setDeviceName() {
    const deviceInputs = document.querySelectorAll('.device');
    const deviceName = this.getDeviceName();

    // Update device name
    if (deviceInputs) {
      deviceInputs.forEach((deviceInput) => {
        deviceInput.value = deviceName;
      });
    }
  }

  // Function to set the order notes value for browser name & version
  setBrowserInfo() {
    // getting order notes node selectors
    const browserInputs = document.querySelectorAll('.browser-name');
    const browserVersionInputs = document.querySelectorAll('.browser-version');

    // getting user browser data
    const { browserName } = this.getBrowserInfo();
    const { browserVersion } = this.getBrowserInfo();

    // Update browser name
    if (browserInputs) {
      browserInputs.forEach((browserInput) => {
        browserInput.value = browserName;
      });
    }

    // Update browser version
    if (browserVersionInputs) {
      browserVersionInputs.forEach((browserVersionInput) => {
        browserVersionInput.value = browserVersion;
      });
    }
  }

  // Function to set the order notes value for IP address
  setUserIp() {
    const ipInputs = document.querySelectorAll('.public-ip-address');
    const getIp = this.getUserIP();

    getIp.then((ipAddress) => {
      // update IP node selectors
      if (ipInputs) {
        ipInputs.forEach((ipInput) => {
          ipInput.value = ipAddress;
        });
      }
    });
  }

  // Function that updates the order notes values
  updateCartNotes() {
    this.setBrowserInfo();
    this.setDeviceName();
    this.setUserIp();
  }

  stickyCheckoutButtons() {
    let selectors = {
      stickyElement: ".make-sticky",
      dynamicExpressBtns: ".cart__dynamic",
      cartBtns: ".cart__footer .cart__ctas",
      stickyCheckoutBtn: ".cart__dynamic-checkout_button",
      GooglePayBtn: "[data-testid='GooglePay-button']",
      stickyBottomBar: ".bottom-announcement-bar",
      footerCookie: ".footer__content-cookie"
    };

    let nodeSelector = {
      stickyElement: document.querySelector(selectors.stickyElement),
      dynamicExpressBtns: document.querySelector(selectors.dynamicExpressBtns),
      cartBtns: document.querySelector(selectors.cartBtns),
      stickyCheckoutBtn: document.querySelector(selectors.stickyCheckoutBtn),
      stickyBottomBar: document.querySelector(selectors.stickyBottomBar),
      footerCookie: document.querySelector(selectors.footerCookie)
    }

    // Hidding Google Pay button on iPhone
    function hideButtonOnDevice(selector, device) {
      if (selector && device && navigator.platform === device) {
        selector.parentElement.classList.add("device-hidden");
      }
    }

    // Show the sticky checkout buttons div
    function showStickyExpressButtons() {
      nodeSelector.dynamicExpressBtns.classList.add("isSticky");
      nodeSelector.footerCookie.classList.add("checkoutIsSticky");
      nodeSelector.stickyCheckoutBtn.classList.remove("hidden");
      nodeSelector.dynamicExpressBtns.querySelector(".cart__dynamic-sticky-buttons").style.transform = "translateY(0)";
    }

    // Hide the sticky checkout buttons div
    function hideStickyExpressButtons() {
      nodeSelector.dynamicExpressBtns.classList.remove("isSticky");
      nodeSelector.footerCookie.classList.remove("checkoutIsSticky");
      nodeSelector.stickyCheckoutBtn.classList.add("hidden");
      nodeSelector.dynamicExpressBtns.querySelector(".cart__dynamic-sticky-buttons").removeAttribute("style");
    }

    // Main logic for making the checkout buttons sticky
    function makeExpressButtonsSticky() {
      var checkoutBtnsOffset = nodeSelector.cartBtns.offsetTop - window.innerHeight;
      var expressBtnsOffset = nodeSelector.dynamicExpressBtns.offsetTop;
      var expressBtnsHeight = nodeSelector.dynamicExpressBtns.offsetHeight;

      // if scrolling before or after payment buttons, show sticky buttons
      if (window.scrollY < checkoutBtnsOffset || window.scrollY > (expressBtnsOffset + expressBtnsHeight - 50)) {
        showStickyExpressButtons();
      }
      // if intersecting the payment buttons, hide sticky buttons
      else if (window.scrollY > checkoutBtnsOffset && window.scrollY < (expressBtnsOffset + expressBtnsHeight)) {
        hideStickyExpressButtons();
      }
    }

    // Reposition sticky checkout buttons over the bottom sticky bar if it exists
    function repositionOverAnnouncementBar() {
      if(nodeSelector.stickyBottomBar && !nodeSelector.stickyBottomBar.classList.contains("hidden")) {
        nodeSelector.stickyElement.classList.add("reposition");
      } else {
        nodeSelector.stickyElement.classList.remove("reposition");
      }
    }

    // Creates an observer to wait for Express Checkout buttons to appear on screen
    function waitForExpressCheckoutBtns(selector) {
      const observer = new MutationObserver((mutations) => {
        makeExpressButtonsSticky();
        repositionOverAnnouncementBar();

        window.addEventListener("scroll", () => {
          makeExpressButtonsSticky();
          repositionOverAnnouncementBar();
          hideButtonOnDevice(document.querySelector(selectors.GooglePayBtn), "iPhone");
        });
      });

      observer.observe(selector, { childList: true, subtree: true });
    }

    function init() {
      if (nodeSelector.stickyElement) {
        waitForExpressCheckoutBtns(nodeSelector.stickyElement);
      }
    }

    // Initialise function
    init();
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};